
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesItemsBOMGrid extends Serenity.EntityGrid<POSSalesItemsBOMRow, any> {
        protected getColumnsKey() { return 'Retail.POSSalesItemsBOM'; }
        protected getDialogType() { return POSSalesItemsBOMDialog; }
        protected getIdProperty() { return POSSalesItemsBOMRow.idProperty; }
        protected getInsertPermission() { return POSSalesItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesItemsBOMRow.localTextPrefix; }
        protected getService() { return POSSalesItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}